import React from 'react';

export default function CommissionRevenuePolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">
        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">
          Commission &amp; Revenue Sharing Policy
        </h1>

        <p className="text-gray-700 mb-8">
          This policy outlines how commissions, platform fees, and revenue shares operate inside Million2Trillion (M2T) for monetized users, advisors, educators, partners, and financial contributors.
        </p>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Standard Platform Fees</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>M2T applies platform commissions on certain monetized services such as: signal subscriptions, courses, consulting packages, coaching programs, product sales, or custom service fees.</li>
          <li>Standard platform commission rates may vary between 10% — 30% depending on product category, user verification level, or membership plan.</li>
          <li>All platform commissions are automatically deducted before payout and displayed in detailed earning statements inside user dashboards.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Revenue Distribution Timing</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Payouts are typically processed on weekly or bi-weekly cycles, subject to meeting minimum payout thresholds and full KYC compliance.</li>
          <li>M2T may hold funds temporarily if compliance checks, refunds, or fraud reviews are active on associated transactions.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Affiliate &amp; Referral Commissions</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Verified members participating in affiliate or referral programs may receive commission earnings for driving verified sign-ups or product sales.</li>
          <li>Affiliate commission percentages, tiers, and payment schedules will be separately outlined in official partnership agreements.</li>
          <li>Commission abuse, self-referrals, or fake user registrations will lead to affiliate account bans and forfeiture of unpaid commissions.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Refunds &amp; Chargebacks</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>In the event of customer refunds, chargebacks, or dispute losses — associated commissions may be reversed and deducted from future payouts to affected providers.</li>
          <li>Platform reserves authority to mediate financial disputes based on official buyer complaint investigations.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Revenue Share Transparency</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All revenue transactions, commission deductions, and net payouts are fully visible to verified monetized members inside their M2T financial dashboard in real-time.</li>
        </ul>

        <p className="text-gray-500 italic mt-10">
          M2T operates on transparent verified revenue sharing. The platform earns only when verified contributors succeed ethically inside the ecosystem.
        </p>
      </div>
    </div>
  );
}
